import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM, BOOLEAN } from '@/plugins/sdk/fields'
import Consignment from '../Consignment'
import Profile from '../Profile'

export default class extends Resource {
  static name = 'watchlist'

  static get fields () {
    return {
      id: new UUID(),
      profile: new ITEM(Profile),
      consignment: new ITEM(Consignment),
      notes: new STRING(),
      watch_until: new STRING(),
      send_notifications: new BOOLEAN(),
      has_updates: new BOOLEAN(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME()
    }
  }
}
